import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useCollection from 'Hooks/useCollection';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import HoldingOverride from 'Resources/Holding';
import MetaCollectionFormDialog from 'Components/UI/Meta/MetaForm/MetaCollectionFormDialog';

import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';

function HoldingModal({ holdingId, accountId, handleClose }) {
  const { collection, setCollection } = useCollection();
  const { householdResource } = useSimpleHousehold();


  useEffect(() => {
    // Only fetch if you haven't before and you have the required relationship
    if (
      !collection
      && accountId
      && householdResource
      && householdResource.relationship('holdings')
    ) {
      householdResource
        .relationship('holdings')
        .link('related')
        .Get({
          metaOverrideSet: HoldingOverride, // Override resource returned by the get
          params: holdingId ? { id: holdingId, accountId } : { accountId, limit: 0, offset: 0 },
        })
        .then((coll) => {
          if (coll.resources().length() === 0) {
            coll.create({
              metaOverrideSet: HoldingOverride, // Override resources that are created on the collection
              addToCollection: true,
            });
            coll
              .resources()
              .head()
              .attr('householdId', householdResource.id());
          }
          setCollection(coll);
        })
        .catch((err) => {
          displayErrorMessage(err, err.errors);
        });
    }
  }, [householdResource]);

  const onSuccess = () => {
    displaySuccess('Holding saved');
    handleClose();
  };

  const onDelete = () => {
    displaySuccess('Holding Deleted');
    handleClose();
  };

  const onFailure = (err) => {
    displayErrorMessage(err, err.errors);
  };

  if (!collection) return null;

  return (
    <MetaCollectionFormDialog
      collection={collection}
      onClose={handleClose}
      onFailure={onFailure}
      onSubmit={onSuccess}
      onDelete={holdingId ? onDelete : null}
      title={holdingId ? 'Edit Holding' : 'Add Holding'}
      deleteMessage="Delete holding?"
    />
  );
}

HoldingModal.defaultProps = {
  holdingId: null,
  accountId: null,
  handleClose: null,
};

HoldingModal.propTypes = {
  holdingId: PropTypes.string,
  accountId: PropTypes.string,
  handleClose: PropTypes.func,
};

export default HoldingModal;
